import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus, Minus } from "lucide-react";

export default function FAQAccordion({ items = [], testIdPrefix = "faq" }) {
  const [open, setOpen] = useState(-1);
  return (
    <ul className="border-t border-line">
      {items.map((it, i) => {
        const isOpen = open === i;
        return (
          <li key={i} className="border-b border-line">
            <button
              type="button"
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="w-full py-4 md:py-8 flex items-start gap-4 md:gap-10 text-left group"
              data-testid={`${testIdPrefix}-toggle-${i}`}
              aria-expanded={isOpen}
            >
              <span className="font-mono text-[10px] md:text-xs text-[#5B6472] pt-1.5 md:pt-2 min-w-[3ch]">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="flex-1 font-serif text-base md:text-3xl text-[#0B2545] leading-tight tracking-tight">
                {it.q}
              </span>
              <span className="pt-1 md:pt-2 text-[#0B2545] shrink-0">
                {isOpen ? (
                  <Minus className="h-4 w-4 md:h-6 md:w-6" strokeWidth={1.5} />
                ) : (
                  <Plus className="h-4 w-4 md:h-6 md:w-6" strokeWidth={1.5} />
                )}
              </span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  key="body"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                >
                  <div className="pl-[calc(3ch+1rem)] md:pl-[calc(3ch+2.5rem)] pr-4 md:pr-6 pb-5 md:pb-8 max-w-3xl">
                    <p className="text-[#5B6472] text-sm md:text-lg leading-relaxed">
                      {it.a}
                    </p>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </li>
        );
      })}
    </ul>
  );
}
